export const faqs = [
  {
    q: "“伦理电影”到底指哪一类作品？",
    a: "在中文语境里，它通常指以家庭、婚姻、亲密关系或社会道德处境为核心的作品。它们往往不靠大场面，而是把重心放在人物之间的选择和沟通上，因此常被归到剧情片里单独讨论。",
  },
  {
    q: "“中字”和“中文字幕”是同一件事吗？",
    a: "基本上是同一件事的两种说法，都指带有中文字幕的版本。区别主要在来源与质量：有的字幕更贴近原意，有的偏向意译，语气、俚语和称谓的差别会直接影响你对人物关系的理解。",
  },
  {
    q: "为什么大家都强调“高清”？",
    a: "这类电影的表演和情绪常常藏在细微处，比如一个停顿、一个眼神、室内光线的变化。清晰度越高，这些细节越不容易被压缩画质吃掉，观感也更接近创作者原本想呈现的样子。",
  },
  {
    q: "“合集”一般怎么组织？",
    a: "常见有按主题（如家庭、婚姻）、按年代、按导演或按演员来整理。本站的片单按主题分类，你可以直接用标签筛选，把同一个话题下的作品放在一起看，理解会更连贯。",
  },
  {
    q: "“经典”和“推荐”有什么不一样？",
    a: "经典更偏向经过时间检验、经常被引用的作品；推荐则更贴近个人当下的观感与需要。前者适合系统了解这一类电影，后者适合先找一部能立刻看进去的。",
  },
  {
    q: "片单里的年份和地区可信吗？",
    a: "片名、年份与出品地区都是公开可查的基础信息。作品解读部分是基于主题的一般性说明，帮助你判断是否对味，并不替代完整的剧情介绍或影评。",
  },
];